import { Configuration, ElementRegistry, ObjectElementFactory } from "duice";
import { CodemirrorElement } from "./CodemirrorElement";
/**
 * Codemirror Factory
 */
export class CodemirrorElementFactory extends ObjectElementFactory {
    /**
     * Creates element
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     */
    createElement(htmlElement, bindData, context) {
        return new CodemirrorElement(htmlElement, bindData, context);
    }
}
/**
 * Static block
 */
(() => {
    // register
    ElementRegistry.register(`${Configuration.getNamespace()}-codemirror`, new CodemirrorElementFactory());
})();
//# sourceMappingURL=CodemirrorElementFactory.js.map